import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Checkbox,
  FormGroup,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  MenuItem,
  Paper,
} from "@material-ui/core";
import {
  SelectValidator, TextValidator,
} from "react-material-ui-form-validator";

import { useForm } from "../../../../hooks/useForm";
import { TIPO_SOLICITUD_INTEGRACION } from "../../data/constants";
import {
  getTiposPrestacionesDiscapacidad,
  updateSolicitudAdicciones,
  updateSolicitudDiscapacidadTerapia
} from "../../../../actions/adicciones/adiccionesActions";
import { diasSemana } from "../../../../utils/constants";

export const AdiccionesComplementoTerapia = ({ setHaveChangeValues, disabled }) => { 
  const dispatch = useDispatch();

  const {
    solicitudSeleccionada = {},
    tiposPrestaciones = [],
  } = useSelector((state) => state.adicciones);

  let integracionTerapiaDefault = {
    idSolicitud: solicitudSeleccionada?.idSolicitud,
    lunes: false,
    martes: false,
    miercoles: false,
    jueves: false,
    viernes: false,
    sabado: false,
    idTipoPrestacion: "",
    horarios: ""
  };

  const [
    formValues,
    handleInputChange,
  ] = useForm(
    !!solicitudSeleccionada?.integracionTerapia
      ? solicitudSeleccionada.integracionTerapia
      : integracionTerapiaDefault
  );

  const {
    idTipoPrestacion,
  } = formValues;

  const errorDias = (!formValues.lunes && !formValues.martes && !formValues.miercoles &&
    !formValues.jueves && !formValues.viernes && !formValues.sabado);

  useEffect(() => {
    if (solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.TERAPIA_MODULO ||
      solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.TERAPIA_INDIVIDUAL)
      dispatch(getTiposPrestacionesDiscapacidad());
  }, [dispatch]);

  const handleInputChangeTerapia = (name, value) => {
    if (name) {
      if (!solicitudSeleccionada.integracionTerapia) {
        dispatch(updateSolicitudAdicciones('integracionTerapia', integracionTerapiaDefault));
      }
      dispatch(updateSolicitudDiscapacidadTerapia(name, value));
      handleInputChange({ target: { name: name, value: value } })
      setHaveChangeValues(true);
    }
  }

  return (
    <Grid
      container
      spacing={2}
      style={{ display: "flex", justifyContent: "center" }}
    >
      <Grid item xs={12} style={{ maxWidth: 700 }} >
        <Paper style={{ marginTop: 5, textAlign: 'center' }}>
          <FormControl required error={errorDias} component="fieldset" >
            <FormGroup row>
              {diasSemana.filter(s => s.value !== 'DO').map((item) => (
                <FormControlLabel
                  key={item.value}
                  control={
                    <Checkbox
                      name={item.value2}
                      checked={formValues[item.value2]}
                      onClick={(e) => handleInputChangeTerapia(item.value2, e.target.checked)}
                      disabled={disabled}
                    />
                  }
                  label={item.display}
                />
              ))}
            </FormGroup>
            {errorDias &&
              <FormHelperText style={{ textAlign: 'center' }}>Debe seleccionar por lo menos un día</FormHelperText>
            }
          </FormControl>
          <Grid style={{ marginLeft: '2rem', marginRight: '2rem' }}>
            <TextValidator
              margin="normal"
              value={formValues.horarios ?? ''}
              inputProps={{ style: { textTransform: "uppercase" } }}
              label="Horarios"
              name="horarios"
              onChange={(e) => handleInputChangeTerapia(e.target.name, e.target.value)}
              autoComplete="off"
              disabled={disabled}
              fullWidth
            />
          </Grid>

        </Paper>
      </Grid>
      <Grid item xs={6}>
        <SelectValidator
          fullWidth
          margin="normal"
          disabled={disabled}
          label="Tipo de Prestacion"
          name="idTipoPrestacion"
          value={idTipoPrestacion}
          onClick={(e) => handleInputChangeTerapia(e.target.name, e.target.value)}
          validators={["required"]}
          errorMessages={["Este campo es requerido"]}
        >
          {tiposPrestaciones.map((item) => (
            <MenuItem
              key={item.idTipoPrestacion}
              value={item.idTipoPrestacion}
            >
              {item.descripcion}
            </MenuItem>

          ))}
        </SelectValidator>
      </Grid>
    </Grid>
  )
}
